import { render, staticRenderFns } from "./SuperAdminCustodyWallet.vue?vue&type=template&id=621e7658&lang=pug"
import script from "./SuperAdminCustodyWallet.vue?vue&type=script&lang=ts"
export * from "./SuperAdminCustodyWallet.vue?vue&type=script&lang=ts"
import style0 from "./SuperAdminCustodyWallet.vue?vue&type=style&index=0&id=621e7658&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
